import React from 'react';
import { Button, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import About from '../About/About';
import Achievements from '../Achievements/Achievements';
import Banner from '../Banner/Banner';
import Packages from '../Packages/Packages';
import './Home.css';

const Home = () => {
    return (
        <div id='top'>
            <Banner></Banner>
            <Packages></Packages>
            <About></About>
            <Achievements></Achievements>
            <HashLink id='float_Button' to='/#banner'><Image src='https://cdn-icons-png.flaticon.com/64/892/892692.png'/></HashLink>
        </div>
    );
};

export default Home;